





























import { Vue, Component, Prop, Watch, Ref } from "vue-property-decorator";
@Component({ inheritAttrs: false })
export default class ppdwTextField extends Vue {
    /** Лейбл над полем ввода, если пустая строка, то он не будет занимать место */
    @Prop({ default: "" }) label: string;
    /** Для костылеплейсхолдера */
    @Prop({ default: "" }) dataPlaceholder: string;
    /** Для лейбла */
    @Prop({ default: false }) disabled: boolean;
    /** Первая всегда заглавная */
    @Prop(Boolean) capitalize: boolean;

    /**
     * Набор правил для ограничения вводимых символов,
     * если не указывать или указать пустой array, то не будет ограничивать */
    @Prop({ default: () => [] }) limitRules: Function[];

    @Prop({ default: () => [] }) rules: Function[];
    @Prop({ default: null }) value: any;
    model: string = "";
    @Ref("reactpls") field: {
        $el: HTMLElement;
        initialValue: string;
        lazyValue: string;
        isFocused: boolean;
        validate: Function;
    };

    @Watch("value") setModel() {
        this.model = this.value;
    }
    mounted() {
        if (this.value) {
            this.setModel();
            this.checkSuccess(this.value, this.rules);
        }
        this.updatePlaceholder();
    }
    @Watch("dataPlaceholder") updatePlaceholder() {
        if (this.dataPlaceholder)
            this.field.$el
                .querySelector(".v-text-field__slot")
                .setAttribute("data-placeholder", this.dataPlaceholder); // place data-placeholder on .v-text-field__slot
    }
    /** Контроль вводимых символов, основанный на наборе правил limitRules */
    limitInputByRules(val) {
        let correct = false;
        for (let rule of this.limitRules) {
            if (typeof rule(val) === "string") {
                correct = false;
                break;
            } else correct = true;
        }
        if (correct) {
            this.model = val;
            this.$emit("input", this.model);
        } else {
            this.field.lazyValue = this.model;
        }
    }

    handleInput(val) {
        if (this.limitRules.length == 0) {
            this.model = val;
            this.$emit("input", this.model);
            return;
        }
        this.limitInputByRules(val);
    }
    async handleBlur(val) {
        let value = this.value;
        if (this.capitalize)
            value =
                value.charAt(0).toUpperCase() + value.slice(1).toLowerCase();
        this.$emit("input", value);
        this.checkSuccess(value, this.rules);
        this.$emit("blur", val);
        await this.$nextTick();
        this.field.validate();
    }
    @Prop({ default: true }) successable: boolean;
    success: boolean = false;
    checkSuccess(value, rules) {
        if (!rules) {
            this.success = true;
            return;
        }
        let state = false;
        for (let rule of rules) {
            if (typeof rule(value) === "string") {
                state = false;
                break;
            } else state = true;
        }
        this.success = state;
    }
}
